@theme {
  --color-primary-50: var(--primary-50);
  --color-primary-100: var(--primary-100);
  --color-primary-150: var(--primary-150);
  --color-primary-200: var(--primary-200);
  --color-primary-250: var(--primary-250);
  --color-primary-300: var(--primary-300);
  --color-primary-350: var(--primary-350);
  --color-primary-400: var(--primary-400);
  --color-primary-450: var(--primary-450);
  --color-primary-500: var(--primary-500);
  --color-primary-550: var(--primary-550);
  --color-primary-600: var(--primary-600);
  --color-primary-650: var(--primary-650);
  --color-primary-700: var(--primary-700);
  --color-primary-750: var(--primary-750);
  --color-primary-800: var(--primary-800);
  --color-primary-850: var(--primary-850);
  --color-primary-900: var(--primary-900);
  --color-primary-950: var(--primary-950);
  --color-accent-50: var(--accent-50);
  --color-accent-100: var(--accent-100);
  --color-accent-150: var(--accent-150);
  --color-accent-200: var(--accent-200);
  --color-accent-250: var(--accent-250);
  --color-accent-300: var(--accent-300);
  --color-accent-350: var(--accent-350);
  --color-accent-400: var(--accent-400);
  --color-accent-450: var(--accent-450);
  --color-accent-500: var(--accent-500);
  --color-accent-550: var(--accent-550);
  --color-accent-600: var(--accent-600);
  --color-accent-650: var(--accent-650);
  --color-accent-700: var(--accent-700);
  --color-accent-750: var(--accent-750);
  --color-accent-800: var(--accent-800);
  --color-accent-850: var(--accent-850);
  --color-accent-900: var(--accent-900);
  --color-accent-950: var(--accent-950);
  --color-grey-50: var(--grey-50);
  --color-grey-100: var(--grey-100);
  --color-grey-150: var(--grey-150);
  --color-grey-200: var(--grey-200);
  --color-grey-250: var(--grey-250);
  --color-grey-300: var(--grey-300);
  --color-grey-350: var(--grey-350);
  --color-grey-400: var(--grey-400);
  --color-grey-450: var(--grey-450);
  --color-grey-500: var(--grey-500);
  --color-grey-550: var(--grey-550);
  --color-grey-600: var(--grey-600);
  --color-grey-650: var(--grey-650);
  --color-grey-700: var(--grey-700);
  --color-grey-750: var(--grey-750);
  --color-grey-800: var(--grey-800);
  --color-grey-850: var(--grey-850);
  --color-grey-900: var(--grey-900);
  --color-grey-950: var(--grey-950);
}

:root {
  --primary-50: hsl(196, 100%, 97.058824%);
  --primary-100: hsl(200, 100%, 94.705882%);
  --primary-150: hsl(198.461538, 95.121951%, 91.960784%);
  --primary-200: hsl(199.2, 92.592593%, 89.411765%);
  --primary-250: hsl(198.181818, 97.058824%, 86.666667%);
  --primary-300: hsl(197.560976, 100%, 83.921569%);
  --primary-350: hsl(197.142857, 100%, 80.784314%);
  --primary-400: hsl(196.173913, 100%, 77.45098%);
  --primary-450: hsl(199.636364, 100%, 67.647059%);
  --primary-500: hsl(202.396313, 100%, 57.45098%);
  --primary-550: hsl(206.352941, 100%, 50%);
  --primary-600: hsl(217.339056, 98.312236%, 53.529412%);
  --primary-650: hsl(216.6, 89.285714%, 43.921569%);
  --primary-700: hsl(216.071429, 94.382022%, 34.901961%);
  --primary-750: hsl(216.716418, 97.101449%, 27.058824%);
  --primary-800: hsl(217.2, 100%, 19.607843%);
  --primary-850: hsl(219.74026, 100%, 15.098039%);
  --primary-900: hsl(222.545455, 100%, 10.784314%);
  --primary-950: hsl(229.411765, 100%, 6.666667%);
  --accent-50: hsl(351.428571, 100%, 98.627451%);
  --accent-100: hsl(350.769231, 100%, 97.45098%);
  --accent-150: hsl(350.526316, 100%, 96.27451%);
  --accent-200: hsl(350.4, 100%, 95.098039%);
  --accent-250: hsl(351.666667, 100%, 92.941176%);
  --accent-300: hsl(351.25, 100%, 90.588235%);
  --accent-350: hsl(351.864407, 100%, 88.431373%);
  --accent-400: hsl(352.394366, 100%, 86.078431%);
  --accent-450: hsl(353.195876, 87.387387%, 78.235294%);
  --accent-500: hsl(354.098361, 79.220779%, 69.803922%);
  --accent-550: hsl(353.557047, 73.399015%, 60.196078%);
  --accent-600: hsl(348.556701, 82.20339%, 46.27451%);
  --accent-650: hsl(347.368421, 85.929648%, 39.019608%);
  --accent-700: hsl(345.810811, 91.358025%, 31.764706%);
  --accent-750: hsl(344.878049, 95.348837%, 25.294118%);
  --accent-800: hsl(344.848485, 100%, 19.411765%);
  --accent-850: hsl(347.368421, 100%, 14.901961%);
  --accent-900: hsl(351.111111, 100%, 10.588235%);
  --accent-950: hsl(354.545455, 100%, 6.470588%);
  --grey-50: hsl(0, 0%, 98.039216%);
  --grey-100: hsl(0, 0%, 96.078431%);
  --grey-150: hsl(0, 0%, 94.117647%);
  --grey-200: hsl(0, 0%, 92.156863%);
  --grey-250: hsl(200, 5.660377%, 89.607843%);
  --grey-300: hsl(195, 6.060606%, 87.058824%);
  --grey-350: hsl(197.142857, 8.860759%, 84.509804%);
  --grey-400: hsl(200, 9.89011%, 82.156863%);
  --grey-450: hsl(204, 6.25%, 68.627451%);
  --grey-500: hsl(198, 4.385965%, 55.294118%);
  --grey-550: hsl(198, 4.587156%, 42.745098%);
  --grey-600: hsl(201.818182, 7.006369%, 30.784314%);
  --grey-650: hsl(204, 7.352941%, 26.666667%);
  --grey-700: hsl(204, 8.62069%, 22.745098%);
  --grey-750: hsl(204, 10.416667%, 18.823529%);
  --grey-800: hsl(206.666667, 11.688312%, 15.098039%);
  --grey-850: hsl(205.714286, 12.727273%, 10.784314%);
  --grey-900: hsl(204, 15.151515%, 6.470588%);
  --grey-950: hsl(210, 28.571429%, 2.745098%);
}
